// extracted by mini-css-extract-plugin
export default {"wrapper":"sound__wrapper__DaDi7","muted":"sound__muted___qTkh"};